// Get environment configuration from runtime injection
const getEnvConfig = () => {
    return window?.process?.env || {};
};

// Export the configuration
export default getEnvConfig();
